import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import {
  CareerPageDescription,
  CareerPageDivider,
  CareerPageSection,
  CareerPageTitle,
} from '../styled'

export function JobDescription({ description }) {
  const { t } = useTranslation()

  return (
    <CareerPageSection>
      <CareerPageTitle>{t('pages.jobDescription')}</CareerPageTitle>
      <CareerPageDivider />
      <CareerPageDescription
        dangerouslySetInnerHTML={{ __html: description }}
      />
    </CareerPageSection>
  )
}

JobDescription.propTypes = {
  description: PropTypes.string.isRequired,
}
